import React from 'react';
import { 
  Facebook, 
  Twitter, 
  Linkedin, 
  Instagram,
  Mail,
  Phone,
  MapPin,
  ArrowRight
} from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="relative bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900 text-white overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-r from-orange-500/5 to-red-500/5"></div>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main footer content */}
        <div className="py-16">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
            {/* Company info */}
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <Logo className="mb-6" />
                <p className="text-gray-400 text-lg mb-8 max-w-md">
                  {t('footer.description')}
                </p>
                {/* <div className="flex space-x-4">
                  {[Facebook, Twitter, Linkedin, Instagram].map((Icon, index) => (
                    <motion.a
                      key={index}
                      href="#"
                      whileHover={{ scale: 1.1, y: -2 }}
                      className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-lg flex items-center justify-center text-white hover:shadow-lg hover:shadow-orange-500/25 transition-all duration-300"
                    >
                      <Icon className="w-5 h-5" />
                    </motion.a>
                  ))}
                </div> */}
              </motion.div>
            </div>
            
            {/* Quick links */}
            <div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                viewport={{ once: true }}
              >
                {/* <h4 className="text-xl font-bold mb-6 bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
                  {t('footer.product.title')}
                </h4> */}
                {/* <ul className="space-y-4">
                  {['features', 'pricing', 'integrations', 'demo', 'support'].map((item, index) => (
                    <li key={index}>
                      <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center group">
                        <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                        {t(`footer.product.${item}`)}
                      </a>
                    </li>
                  ))}
                </ul> */}
              </motion.div>
            </div>
            
            {/* Contact info */}
            <div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <h4 className="text-xl font-bold mb-6 bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
                  {t('footer.contact.title')}
                </h4>
                <ul className="space-y-4">
                  <li className="flex items-center text-gray-400 hover:text-white transition-colors">
                    <div className="w-10 h-10 bg-orange-500/10 rounded-lg flex items-center justify-center mr-3">
                      <Mail className="w-5 h-5 text-orange-400" />
                    </div>
                    <div>
                      <div className="text-sm text-gray-500">{t('footer.contact.email')}</div>
                      <div>info@tapeat.com</div>
                    </div>
                  </li>
                  <li className="flex items-center text-gray-400 hover:text-white transition-colors">
                    <div className="w-10 h-10 bg-orange-500/10 rounded-lg flex items-center justify-center mr-3">
                      <Phone className="w-5 h-5 text-orange-400" />
                    </div>
                    <div>
                      <div className="text-sm text-gray-500">{t('footer.contact.phone')}</div>
                      <div>+351 968 682 315</div>
                    </div>
                  </li>
                  <li className="flex items-center text-gray-400 hover:text-white transition-colors">
                    <div className="w-10 h-10 bg-orange-500/10 rounded-lg flex items-center justify-center mr-3">
                      <MapPin className="w-5 h-5 text-orange-400" />
                    </div>
                    <div>
                      <div className="text-sm text-gray-500">{t('footer.contact.location')}</div>
                      <div>Açores, Portugal</div>
                    </div>
                  </li>
                </ul>
              </motion.div>
            </div>
          </div>
        </div>
        
        {/* CTA Section */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="py-12 border-t border-gray-800"
        >
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-4">{t('footer.readyToStart.title')}</h3>
            <p className="text-gray-400 mb-8 max-w-2xl mx-auto">
              {t('footer.readyToStart.description')}
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-gradient-to-r from-orange-500 to-red-600 text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-orange-500/25 transition-all duration-300 flex items-center mx-auto"
            >
              {t('footer.readyToStart.button')}
              <ArrowRight className="ml-2 h-5 w-5" />
            </motion.button>
          </div>
        </motion.div> */}
        
        {/* Bottom bar */}
        <div className="py-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
              className="text-gray-500 text-sm"
            >
              {t('footer.copyright')}
            </motion.p>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              viewport={{ once: true }}
              className="flex space-x-6 mt-4 md:mt-0"
            >
              <Link
                to="/privacy"
                className="text-gray-500 hover:text-orange-400 text-sm transition-colors"
              >
                {t('footer.links.privacy')}
              </Link>
              <Link
                to="/terms"
                className="text-gray-500 hover:text-orange-400 text-sm transition-colors"
              >
                {t('footer.links.terms')}
              </Link>
              <Link
                to="/cookies"
                className="text-gray-500 hover:text-orange-400 text-sm transition-colors"
              >
                {t('footer.links.cookies')}
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;